export default __webpack_public_path__ + "ba3c8d4414ce16757afd2e8585ef50a9.png";